import {COMMON_BUILDING_TOKENS, KEY_POINT_TOKENS} from "../../../constants/tokens";
import {getNeighborHexKeys} from "../botGrid";
import {getAllQuartersOfCity} from "../../gameState/getAllQuartersOfCity";
import {getCityHexKeys} from "../../gameState/getCityHexKeys";
import {NEUTRAL_PLAYER_ID} from "../../../constants/players";

// Ценность блокируемых активов (по рекомендации живого теста 10):
// очень высокая — Великие руины; высокая — Великие рудники, руины, фермы,
// спецстроения; обычная — рудники и прочие строения
const BLOCK_VALUE_SUPER_RUINS = 4;
const BLOCK_VALUE_HIGH = 2.5;
const BLOCK_VALUE_NORMAL = 1.5;

const KEY_POINT_BLOCK_VALUES = {
  [KEY_POINT_TOKENS.SUPER_RUINS]: BLOCK_VALUE_SUPER_RUINS,
  [KEY_POINT_TOKENS.SUPER_MINE]: BLOCK_VALUE_HIGH,
  [KEY_POINT_TOKENS.RUINS]: BLOCK_VALUE_HIGH,
  [KEY_POINT_TOKENS.MINE]: BLOCK_VALUE_NORMAL,
};

/**
 * Ценность активов игрока, которые блокирует каждый отряд противника:
 * отряд НА или СМЕЖНО нашей контролируемой ключевой точке лишает ее дохода;
 * отряд НА нашем строении выключает его функцию (найм, снабжение, спецэффект).
 *
 * Возвращает Map(enemyUnitId -> суммарная ценность блокируемого).
 */
export const calcEnemyBlockedAssetValues = (botPlayer, units, citiesCache, specialBuildings, gridRenderer) => {
  const blockValues = new Map();
  const playerCities = citiesCache?.[botPlayer.color] || [];
  if (playerCities.length === 0) {
    return blockValues;
  }

  // Ценность по ячейкам: ключевые точки (блокируются на точке и смежно),
  // строения (блокируются только стоя на ячейке)
  const keyPointValueByCell = new Map();
  const buildingValueByCell = new Map();

  playerCities.forEach((city) => {
    Object.entries(KEY_POINT_BLOCK_VALUES).forEach(([kpToken, value]) => {
      (city[kpToken] || []).forEach((cellKey) => keyPointValueByCell.set(cellKey, value));
    });

    (city[COMMON_BUILDING_TOKENS.FARM] || []).forEach((cellKey) =>
      buildingValueByCell.set(cellKey, BLOCK_VALUE_HIGH)
    );
    getCityHexKeys(city).forEach((cellKey) => {
      if (specialBuildings[cellKey]) {
        buildingValueByCell.set(cellKey, BLOCK_VALUE_HIGH);
      }
    });
    (city[COMMON_BUILDING_TOKENS.BARRACKS] || []).forEach((cellKey) => {
      if (!buildingValueByCell.has(cellKey)) {
        buildingValueByCell.set(cellKey, BLOCK_VALUE_NORMAL);
      }
    });
    getAllQuartersOfCity(city).forEach((cellKey) => {
      if (!buildingValueByCell.has(cellKey)) {
        buildingValueByCell.set(cellKey, BLOCK_VALUE_NORMAL);
      }
    });
  });

  units.forEach((unit) => {
    if (unit.ownerId === botPlayer.id || unit.ownerId === NEUTRAL_PLAYER_ID) {
      return;
    }
    let value = 0;
    if (keyPointValueByCell.has(unit.hexKey)) {
      value += keyPointValueByCell.get(unit.hexKey);
    } else {
      // Смежность к точке тоже блокирует ее доход — считаем самую ценную из смежных
      let bestAdjacent = 0;
      getNeighborHexKeys(unit.hexKey, gridRenderer).forEach((adjKey) => {
        const adjValue = keyPointValueByCell.get(adjKey);
        if (adjValue && adjValue > bestAdjacent) {
          bestAdjacent = adjValue;
        }
      });
      value += bestAdjacent;
    }
    if (buildingValueByCell.has(unit.hexKey)) {
      value += buildingValueByCell.get(unit.hexKey);
    }
    if (value > 0) {
      blockValues.set(unit.id, value);
    }
  });

  return blockValues;
};
